import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      if (cartItems.length > 0) navigate('/checkout'); else navigate('/');
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'No se pudo iniciar sesión.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4 md:p-12 min-h-screen md:flex md:flex-col md:items-center md:justify-start pt-[96px] md:pt-24" style={{ backgroundColor: '#FFFBF7' }}>
      <h1 className="text-3xl font-semibold text-gray-800 mb-8 md:text-center md:w-full">Iniciar sesión</h1>
      <form onSubmit={handleSubmit} className="bg-white p-6 shadow-md rounded-lg max-w-md w-full mx-auto">
        {error && <div className="mb-4 text-red-600">{error}</div>}
        <div className="mb-4">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
          <input id="email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
        </div>
        <div className="mb-6">
          <label htmlFor="password" className="block text-sm font-medium text-gray-700">Contraseña</label>
          <input id="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm" />
          <div className="mt-2 text-right">
            <a href="/forgot-password" className="text-sm text-blue-600 hover:text-blue-500">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
        </div>
        <button type="submit" disabled={loading} className="w-full bg-pink-dark text-white py-3 rounded-lg font-semibold hover:bg-pink-700 transition-colors disabled:opacity-50">
          {loading ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
